import { useQuoteStatusUtils } from '@axo/shared/data-access/hooks';
import { ace_index, loan_quote } from '@axo/shared/data-access/types';
import { LenderName } from './LenderName';

interface Props {
  app: ace_index.LoanApplication;
}

export function ApprovedLenderNames({ app }: Props) {
  const statuses = useQuoteStatusUtils();

  if (app.LoanQuotes === undefined) {
    return null;
  }

  const all = app.LoanQuotes.filter((qoute) =>
    statuses.isInQuoteStatusGroup(
      statuses.fromCode(qoute.StatusCode),
      loan_quote.QuoteStatusGroup.Approved,
    ),
  ).map((qoute) => qoute.LenderID);

  const unique = [...new Set(all)];

  return (
    <span>
      {unique.map((id) => (
        <LenderName
          key={id}
          marketCountry={app.MarketCountryCode}
          lenderID={id}
        />
      ))}
    </span>
  );
}
